"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
const tableData = [{
  type: "Engraved phenolic / metal",
  bestFor: "Permanent installs, harsh/outdoor/high-temp, long service life",
  notes: "Legend is part of the material — solvent-, UV-, and abrasion-resistant"
}, {
  type: "Printed durable label",
  bestFor: "High-volume facility labeling, full-color fields, variable data",
  notes: "Durable substrates and laminates; {{verify: print durability rating}}"
}, {
  type: "Stock format labels",
  bestFor: "Fast, standardized facility rollouts",
  notes: "Order ready-made formats on the product page"
}, {
  type: "Fully custom",
  bestFor: "Project-specific layouts, logos, multi-field specs",
  notes: "Built to the submittal and proof"
}];
export default function EngravedPrintedStockOrCustom() {
  return <section id="engraved-printed-stock-or-custom" className="bg-background text-foreground py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6 max-w-5xl">
        <h2 className="font-default text-3xl md:text-4xl font-bold mb-6 text-foreground">
          Engraved, Printed, Stock, or Custom — Which Arc Flash Label?
        </h2>
        
        <p className="text-lg mb-10 max-w-3xl text-muted-foreground">
          Evermark Industrial Solutions produces arc flash labels in several constructions, matched to the environment and the install.
        </p>

        <div className="border border-border rounded-lg overflow-hidden mb-6 shadow-sm bg-card">
          <Table>
            <TableHeader className="bg-muted/50">
              <TableRow>
                <TableHead className="w-[250px] font-semibold text-secondary">Type</TableHead>
                <TableHead className="w-[300px] font-semibold text-secondary">Best For</TableHead>
                <TableHead className="font-semibold text-secondary">Notes</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {tableData.map((row, i) => <TableRow key={i} data-index={i} className="border-border">
                  <TableCell className="font-medium text-card-foreground">{row.type}</TableCell>
                  <TableCell className="text-muted-foreground">{row.bestFor}</TableCell>
                  <TableCell className="text-muted-foreground">{row.notes}</TableCell>
                </TableRow>)}
            </TableBody>
          </Table>
        </div>

        <p className="text-sm text-muted-foreground mb-8 italic">
          Material durability ratings (temperature, UV, chemical, expected outdoor life): {"{{verify: material durability specs}}"}.
        </p>

        <div className="flex flex-col sm:flex-row gap-6 items-start sm:items-center">
          <Button asChild variant="link" className="p-0 h-auto text-primary hover:text-primary/80 text-base">
            
          </Button>
          <Button asChild variant="link" className="p-0 h-auto text-primary hover:text-primary/80 text-base">
            
          </Button>
        </div>
      </div>
    </section>;
}